import React, { Component } from 'react'
import DragDropFunctions from '~/utils/TemplateEditor/dragDropFunctions'

export default class LabelEditable extends Component {
    constructor(props) {
        super(props)

    }

    render() {

        var eleProps;
        if (this.props.elementData.props) {
            eleProps = DragDropFunctions.generatePropsForStage(this.props.elementData.props, this.props.globalVariables, "label", this.props.localVariables)
        }



        return <label {...eleProps}>
            {this.props.children}
        </label>



    }
}